// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-grid {
  padding: 15px;
  padding-top: 0px;
}
ion-grid ion-row {
  border-radius: 25px;
  background-color: white;
  color: var(--ion-color-primary);
  min-height: 70px;
  margin-bottom: 20px;
}
ion-grid ion-row ion-col {
  padding: 5px;
  display: flex;
  align-items: center;
}
ion-grid ion-row ion-col:first-of-type {
  font-weight: bold;
}
ion-grid ion-row ion-col:last-of-type div {
  width: 150px;
  text-align: center;
}
ion-grid ion-row.hl {
  background-color: var(--ion-color-primary) !important;
  color: white !important;
}
ion-grid ion-row#header {
  background-color: var(--ion-color-primary);
  color: white;
}
ion-grid ion-row#header ion-col div {
  font-weight: bold;
}

.ngx-datatable {
  width: 95%;
  margin: auto;
}

.ngx-datatable.scroll-vertical {
  height: 70vh;
}

.title {
  font-weight: bold;
  font-size: 20px;
}

.body {
  font-size: 18px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/table/table.component.scss"],"names":[],"mappings":"AAAA;EAEI,aAAA;EAEA,gBAAA;AADJ;AAGI;EAEI,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;AAFR;AAIQ;EACI,YAAA;EACA,aAAA;EACA,mBAAA;AAFZ;AAMQ;EAEI,iBAAA;AALZ;AAWY;EACI,YAAA;EACA,kBAAA;AAThB;AAcI;EACI,qDAAA;EACA,uBAAA;AAZR;AAeI;EAEI,0CAAA;EACA,YAAA;AAdR;AAiBQ;EAEI,iBAAA;AAhBZ;;AAuBA;EACI,UAAA;EACA,YAAA;AApBJ;;AAuBA;EACI,YAAA;AApBJ;;AAuBA;EAEI,iBAAA;EACA,eAAA;AArBJ;;AAyBA;EAEI,eAAA;AAvBJ","sourcesContent":["ion-grid{\n\n    padding: 15px;\n\n    padding-top: 0px;\n\n    ion-row {\n\n        border-radius: 25px;\n        background-color: white;\n        color:var(--ion-color-primary);\n        min-height: 70px;\n        margin-bottom: 20px;\n\n        ion-col {\n            padding: 5px;\n            display: flex;\n            align-items: center;\n            // justify-content: center;\n        }\n\n        ion-col:first-of-type {\n            \n            font-weight: bold;\n\n        }\n\n        ion-col:last-of-type {             \n\n            div{                \n                width: 150px;\n                text-align: center;\n            } \n        }\n    }\n\n    ion-row.hl{\n        background-color: var(--ion-color-primary) !important;\n        color:white !important;\n    }\n\n    ion-row#header {\n        \n        background-color: var(--ion-color-primary);\n        color:white;\n\n\n        ion-col div {\n\n            font-weight: bold;\n\n        }\n\n    }\n}\n\n.ngx-datatable {\n    width: 95%;\n    margin: auto;\n}\n\n.ngx-datatable.scroll-vertical {\n    height: 70vh;\n}\n\n.title {\n\n    font-weight: bold;\n    font-size: 20px\n\n}\n\n.body {\n\n    font-size: 18px;\n\n}\n\n// @media screen and (min-width: 768px) {\n//     ion-row {\n//         display: flex;\n//         justify-content: space-between;\n//         // flex: auto !important;\n\n//     }\n\n//     ion-col {\n//         flex-grow: 1;\n//         flex-basis: 0px;\n//         // flex: auto;\n//     }\n// }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
